import {
  Component,
  OnInit,  
  OnDestroy,
} from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder } from "@angular/forms";
import { Router } from "@angular/router";


import {
  ICredentialVerification,
} from "./../../shared/models/products/credential-verification";
import { PurchaseStateService } from "./../../shared/services/purchase-state.service";
import { NotificationsService } from "./../../../shared/services/notifications.service";
import { UserService } from "./../../../shared/services/user.service";
import { Observable, Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";

const SendToOptions = {
  Self: "/purchase/credential-verification/self",
  ThirdParty: "/purchase/credential-verification/third-party",
  StateAgency: "/purchase/credential-verification/state-licensure",
  Email: "/purchase/credential-verification/email",
};

@Component({
  selector: "app-credential-verification",
  templateUrl: "./credential-verification.component.html",
})
export class CredentialVerificationComponent implements OnInit, OnDestroy {
  credentialVerificationForm: UntypedFormGroup;
  sendToOptions = SendToOptions;
  private destroy$ = new Subject<void>();

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private purchaseState: PurchaseStateService,
    private userService: UserService,
    private notifications: NotificationsService
  ) {}

  ngOnInit() {
    // if(this.isExpired()) {
    //   this.notifications.errorWithWait('Warning', 'Your credential(s) will be listed as expired. Are you sure you want to continue?',0);
    //   //if (!window.confirm('Your credential(s) will be listed as expired. Are you sure you want to continue?')) {
    //   //  this.router.navigate(['/']);
    //   //}
    // }
    this.buildForm();
  }

  isExpired(): boolean {
    if (
      this.userService.CurrentUser.hasExpiredCredentials &&
      !this.userService.CurrentUser.credentialHolder
    ) {
      return true;
    }
    return false;
  }
  onSubmit(updatedFormValue) {
    if (updatedFormValue.sendTo) {
      this.updatePurchaseState(updatedFormValue.sendTo);

      this.router.navigate([updatedFormValue.sendTo]);
    } else {
      this.notifications.error("Send To Required", "Please select an option.");
    }
  }

  invalidCRTDate(): Observable<boolean> {
    return this.userService.user$.pipe(
      takeUntil(this.destroy$),
      map((newUser) => (newUser ? newUser.invalidCRTDate : true))
    );
  }

  private buildForm() {
    this.credentialVerificationForm = this.formBuilder.group({
      sendTo: [null],
    });
  }

  private updatePurchaseState(sendTo) {
    const product = <ICredentialVerification>(
      this.purchaseState.getTempProductData()
    );
    switch (sendTo) {
      case this.sendToOptions.StateAgency:
        product.sendToType = "SL";
        break;
      case this.sendToOptions.ThirdParty:
        product.sendToType = "TP";
        break;
      case this.sendToOptions.Email:
        product.sendToType = "E";
        break;
      default:
        product.sendToType = "S";
    }
    this.purchaseState.setTempProductData(product);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
